import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '@common/store';
import { setPageLayoutAction } from '@common/store/reducers';
import { type PageLayout } from '@common/types/store';

const usePageLayout = () => {
  const dispatch = useAppDispatch();
  const pageLayout = useAppSelector((state) => state.main.pageLayout);

  const setPageLayout = useCallback((layout: PageLayout) => {
    dispatch(setPageLayoutAction(layout));
  }, [dispatch]);

  return {
    pageLayout,
    setPageLayout,
    isWindowedLayout: pageLayout === 'windowed',
  };
};

export default usePageLayout;
